type ChevronDownSmallProps = {
    className?: string;
    size?: number;
};

/** RGM TPO — tree row expand control (Figma: chevron-down, node 15300:146384) */
const ChevronDownSmall = ({ className, size = 12 }: ChevronDownSmallProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        className={['transition-transform duration-200 ease-out', className].filter(Boolean).join(' ')}
        aria-hidden
    >
        <path
            d="M3 4.5L6 7.5L9 4.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ChevronDownSmall;
